import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import MarketoFormComponent from '../marketo/marketoFormComponent';
import '../../sass/components/flexibleModules/_components.genericIntroSectionWithGrid.scss';

const GenericIntroSectionWithGrid = ({ data }) => {

    const [marketoFormShow, setMarketoFormShow] = useState(false);
    const showMarketoForm = (val) => {
        setMarketoFormShow(val);
    }

    const scrollToRef = (ref) => {
        if (ref) {
            window.scrollTo({
                top: document.querySelector(ref).offsetTop - 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <div className="cp-genericIntroSectionWithGrid" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericIntroSectionWithGrid__inner l--centerAlign" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.genericIntroSectionWithGridHeader &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.genericIntroSectionWithGridHeader }} />
                }
                {data.genericIntroSectionWithGridTeaser &&
                    <div dangerouslySetInnerHTML={{ __html: data.genericIntroSectionWithGridTeaser }} />
                }
                {data.genericIntroSectionGridSections &&
                    <div className="cp-genericIntroSectionWithGrid__gridSection l--flex">
                        {data.genericIntroSectionGridSections.map((gridSec, index) => (
                            <div className="cp-genericIntroSectionWithGrid__gridSection-sec" key={index}>
                                {gridSec.icon &&
                                    <img src={gridSec.icon.sourceUrl} alt={gridSec.icon.altText} />
                                }
                                <span dangerouslySetInnerHTML={{ __html: gridSec.title }} />
                            </div>
                        ))}
                    </div>
                }
                {data.genericIntroSectionWithGridPostGridTeaser &&
                    <div dangerouslySetInnerHTML={{ __html: data.genericIntroSectionWithGridPostGridTeaser }} />
                }
                {data.genericIntroSectionWithGridPostGridButton &&
                    <>
                        {data.genericIntroSectionWithGridPostGridButton.url === '#cp-marketoFormABTest' ?
                            <button onClick={() => showMarketoForm(true)} className="l-button l-marketo">
                                <span>{data.genericIntroSectionWithGridPostGridButton.title}</span>
                                <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                            </button>
                            :
                            data.genericIntroSectionWithGridPostGridButton.url === '#anchorTop' ?
                                <div className="l-relativeButton">
                                    <button onClick={() => scrollToRef(`.cp-halfHalfMarketocomponent`)} className="l-button">
                                        <span>{data.genericIntroSectionWithGridPostGridButton.title}</span>
                                        <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                    </button>
                                    <button onClick={() => scrollToRef(`.cp-halfHalfMarketocomponent`)} className="l-button l-backgroundHover">
                                        <span>{data.genericIntroSectionWithGridPostGridButton.title}</span>
                                        <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                    </button>
                                </div>
                                :
                                <div className="l-relativeButton">
                                    <a href={data.genericIntroSectionWithGridPostGridButton.url} target={data.genericIntroSectionWithGridPostGridButton.target} className="l-button">
                                        <span>{data.genericIntroSectionWithGridPostGridButton.title}</span>
                                        <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                    </a>
                                    <a href={data.genericIntroSectionWithGridPostGridButton.url} target={data.genericIntroSectionWithGridPostGridButton.target} className="l-button l-backgroundHover">
                                        <span>{data.genericIntroSectionWithGridPostGridButton.title}</span>
                                        <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                    </a>
                                </div>
                        }
                    </>
                }
                {marketoFormShow &&
                    <div className="cp-postPerformEventIntro__formVideo l--flex l--abtestOverride">
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3567" />
                            <button onClick={() => showMarketoForm(false)} className="l-backgroundTrigger"></button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default GenericIntroSectionWithGrid;